import $ from 'jquery';
import LazyLoad from "vanilla-lazyload";
export class LazyloadMedia {
    constructor() {
        new LazyLoad({
            callback_loaded: (element) => {
                if ($(element).parents('.lazyload')) {
                    $(element).parents(".lazyload").addClass("loaded");
                }
            },
        });
    }
}
;
